// extracted by mini-css-extract-plugin
module.exports = {"hiddenEraser":"__6g_bs"};